import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import PutAwayForm from "./PutAwayForm";

const EditPutAway = () => {
  return (
    <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Putaway - Edit</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <PutAwayForm />
      </div>
    </div>
  );
};

export default EditPutAway;
